<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

const props = defineProps({
  conversationId: { type: [Number, String], required: true },
});
const emit = defineEmits(['stay', 'leave']);

const { t } = useI18n();
const store = useStore();

const prefs = computed(() => store.getters.aiAssistPrefsFor(props.conversationId));
const busy = computed(() => store.getters.aiAssistBusyFor(props.conversationId));

const updatePref = patch => {
  if (busy.value) return;
  store.dispatch('updateAiAssistPrefs', {
    conversationId: props.conversationId,
    patch,
  });
};
</script>

<template>
  <div
    class="w-80 p-3 bg-n-solid-1 border border-n-weak rounded-lg shadow-lg text-sm"
    @mouseenter="emit('stay')"
    @mouseleave="emit('leave')"
  >
    <div class="flex items-center justify-between mb-3">
      <span class="font-semibold text-n-slate-12">{{ t('CUSTOM.AI_ASSIST.SETTINGS_TITLE') }}</span>
      <span class="text-[10px] text-n-slate-10 uppercase">AI</span>
    </div>

    <div class="flex items-center justify-between mb-1">
      <div>
        <div class="text-n-slate-12">{{ t('CUSTOM.AI_ASSIST.AUTO_REPLY') }}</div>
        <div class="text-xs text-n-slate-10">{{ t('CUSTOM.AI_ASSIST.AUTO_REPLY_HINT') }}</div>
      </div>
      <button
        type="button"
        class="w-9 h-5 rounded-full relative transition-colors focus:outline-none disabled:opacity-60 disabled:cursor-not-allowed"
        :class="[
          prefs.autoReplyOn ? 'bg-n-brand' : 'bg-n-alpha-2',
          busy ? '' : 'cursor-pointer',
        ]"
        :disabled="busy"
        :aria-pressed="prefs.autoReplyOn"
        @click="updatePref({ autoReplyOn: !prefs.autoReplyOn })"
      >
        <span
          class="absolute top-0.5 w-4 h-4 bg-white rounded-full transition-all"
          :class="prefs.autoReplyOn ? 'left-[18px]' : 'left-0.5'"
        />
      </button>
    </div>
  </div>
</template>
